<template>
    <div class="mysection">
        <h1><img src="../../assets/images/wx_logo_ss.png" border="0" />注册普惠投融平台用户</h1>
        <div class="inputs_profile">
            <el-form ref="form" :model="form" :rules="RegisterRules">
            <el-row>
                <el-col :span="24">
                  <el-form-item label="昵称" prop="username" labelWidth="110px">
                    <el-input v-model="form.username" placeholder="请输入昵称" v-on:blur="showUsername()"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                  <el-form-item label="性别" prop="sex" labelWidth="110px">
                    <el-radio-group v-model="form.sex" class="el-input">
                        <el-radio label="1">男</el-radio>
                        <el-radio label="2">女</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                  <el-form-item label="年龄" prop="age" labelWidth="110px">
                    <el-input v-model="form.age" placeholder="请输入年龄"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                  <el-form-item label="学历" prop="education" labelWidth="110px">
                    <el-select v-model="form.education" placeholder="请选择">
                        <el-option
                                v-for="item in educationArray"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                  <el-form-item label="手机" prop="phoneNumber" labelWidth="110px">
                    <el-input v-model="form.phoneNumber" placeholder="请输入手机号"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                  <el-col :span="24">
                  <el-form-item label="邮箱" prop="email" labelWidth="110px">
                    <el-input  v-model="form.email" placeholder="请输入邮箱"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                  <el-form-item label="图形验证码" prop="codeImage" labelWidth="110px">
                    <el-input  type="text" prop="imgCode" v-model="form.codeImage" placeholder="请输入图形验证码" :disabled="inputCodeImage"></el-input>
                    <img class="img_code" src="" v-bind:class="{disabledChangeCodeImage:clickCodeImage}" id="myCodeImg" @click="showCodeImg"/>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                  <el-form-item label="手机验证码" prop="phoneCaptcha" labelWidth="110px">
                    <el-input v-model="form.phoneCaptcha" placeholder="请输入手机验证码"></el-input>
                    <el-button  v-bind:class="{transparent:showPhoneCaptchaButton}" type="default" class="btn_login_msg" @click="getPhoneCaptcha">{{btntxt}}</el-button>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                  <el-form-item label="密码" prop="password" labelWidth="110px">
                    <el-input v-model="form.password" placeholder="密码由字母和数字组成6到16个字符" type="password"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="user_agreement" :span="24">
                    <el-checkbox v-model="checked">已阅读并同意</el-checkbox>
                    <el-button type="text" @click="dialogVisible = true">《普惠民间借贷服务平台用户协议》</el-button>
                    <el-dialog
                            title="用户协议"
                            :visible.sync="dialogVisible"
                            width="90%"
                            height="60%" center>
                    <span class="pact_con">
                      <h1>《普惠民间借贷服务平台用户协议》</h1>
                      <p>甲方（信息提供人），乙方：<strong>【陕西普惠投融信息服务有限公司】</strong>。乙方帮助合作方在本网站平台进行贷款产品的推广，甲方可通过本网站平台进行贷款产品的申请及相关信息的填写。为明确甲乙双方的权利和义务，本着平等互利的原则，就甲方同意乙方为甲方提供与本网站平台推广的贷款产品相关的服务进行个人信息的收集、使用、存储、披露、传送等活动达成服务协议。</p>
                      <p>甲方在使用乙方提供的网站平台服务之前，请您务必审慎阅读、充分理解本协议，特别是隐私条款、免责条款，点击提交按钮，即表示甲方确认对本协议全部条款含义已充分理解并完全接受。阅读本协议的过程中，如果甲方不同意本协议或其中任何条款约定，应立即停止个人信息提交程序。</p>
                      <p>
                        <h3>一、服务内容与方式</h3>
                        1.1 服务内容：本网站仅提供贷款产品的宣传推广以及个人信息的收集、存储、使用、分析、处理、传送、传输等服务，以最终实现由资金提供方为甲方提供贷款服务的目的。<br />
                        1.2 服务方式：甲方同意乙方为甲方参与本网站平台推出的贷款产品等活动而收集、使用、存储甲方的个人信息，并将甲方个人信息披露、传送给乙方合作方。且进一步同意乙方合作方有权将该等信息传输给资金提供方，供资金提供方对甲方的借款申请进行审核，从而更好地向甲方提供贷款产品的宣传推介、申请、合同订立与履行、贷后等服务。
                      </p>
                      <p>
                        <h3>二、甲方的权利与义务</h3>
                        2.1 甲方自愿在本网站平台填写个人信息，并在提交成功之后有权享有乙方提供的服务。<br />
                        2.2 甲方在提交申请时需要填写合法有效的个人信息；甲方须保证所填写的个人信息和所提供的资料真实、准确、完整，对于因甲方提供的信息不真实、不准确或不完整导致的损失由甲方承担。<br />
                        2.3 甲方自愿提供个人信息并使用本网站提供的服务，确认以本网站要求的技术操作方式填写信息并自愿承担责任。
                      </p>
                      <p>
                        <h3>三、乙方的权利与义务</h3>
                        3.1 因以下情况没有正确执行甲方提交的指令，乙方不承担任何责任：<br />
                        （1）甲方未能按照网站平台的规则进行操作；<br />
                        （2）不可抗力或意外事件；<br />
                        （3）运营商等非乙方可控制原因导致的网络堵塞、中断；<br />
                        （4）其他乙方无过失的情况。<br />
                        3.2 乙方对甲方的个人信息负有保密义务，并保证乙方及必要第三方与乙方具有同等保密责任。但以下 情况除外：<br />
                        （1）应国家相关法律法规的规定或政府部门的要求必须披露；<br />
                        （2）经甲方同意披露。
                      </p>
                      <p>
                        <h3>四、协议的效力</h3>
                        4.1 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效 并且有约束力，除非该其余条款或者本协议整体被法院的最终裁判认定无效。<br />
                        4.2 本协议自甲方完成提交其个人信息时起生效。
                      </p>
                      <p>
                        <h3>五、隐私条款</h3>
                        5.1 甲方同意其个人信息用于以下一项或多项用途：<br />
                        （1）由乙方对收集的甲方个人信息进行数据存储、分析与处理；<br />
                        （2）由乙方将甲方的个人信息提供给合作方及其关联方；<br />
                        （3）由乙方及/或合作方向甲方提供贷款产品及服务的推介、合同订立、履行及贷后服务等贷款经营服务；<br />
                        （4）应甲方的咨询由合作方与甲方联络（包括：短信、电话、邮件以及互联网等方式）；<br />
                        （5）乙方及合作方向甲方发送有关优惠广告、最新推荐或促销优惠等内容；<br />
                        （6）乙方及合作方向甲方推介其他可能感兴趣的金融产品。<br />
                        5.2 为保持数据的准确性，防止非法入侵及确保甲方个人信息的合法、合规使用，乙方采取了适当的硬件、电子及管理措施以保障甲方个人信息的保密性。<br />
                        5.3 乙方收集甲方个人信息的内容包括：<br />
                        （1）个人身份信息：包括但不限于姓名、性别、年龄、出生日期、证件类型、证件号码、手机号码、 联系地址、电子邮件等；<br />
                        （2）个人背景信息：包括但不限于职业、健康情况、兴趣爱好、家庭情况、收入情况等；<br />
                        （3）个人网络信息：使用 Cookies、IP 地址和其它技术方式收集甲方非个人化信息，以使乙方在甲方访问网站时可辨认其身份；<br />
                        （4）其他乙方为提供服务所需要的个人信息。<br />
                        5.4 如甲方系未成年人应事先得到其监护人的同意，监护人应承担未成年人在本网站平台享受服务过程中 隐私权保护的首要责任。<br />
                        5.5 若经未成年人监护人同意，乙方可对未成年人个人信息进行收集，但乙方将会向监护人披露此未成年 人个人信息，监护人的同意包括但不限于口头的、书面的或者其他形式。<br />
                        5.6 甲方及其监护人应对己方所提供信息的真实性负责，如乙方无法从甲方所提供信息判断出甲方为未成年人，那么乙方则不承担保护未成年隐私权的责任。<br />
                        5.7 某些服务需由乙方的合作伙伴（包括但不限于提供相关技术服务商、信息服务商、邮寄公司、提供奖品公司等）提供或共同提供，为了向甲方提供此类服务，乙方有必要将从乙方获取的甲方个人信息与提供该服务的合作伙伴共享。<br />
                        5.8 乙方及其合作伙伴承诺除为提供本协议约定之服务以外，不会将甲方的个人信息用于其他商业目的，也 不会将甲方的个人信息泄露给任何无关第三方。乙方承诺采取严格的隐私政策，尊重并保护甲方隐私，请甲方仔细阅读本条款并了解；本条款自本 协议签署时生效，具有独立法律效力，不因协议未生效或无效而受影响。
                      </p>
                      <p>
                        <h3>六、法律适用与争议解决</h3>
                        6.1 本协议的成立、生效、履行和解释，均适用中国人民共和国法律；法律无明文规定的，可适用通行的行业惯例。如本协议相关条款与中华人民共和国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它条款则依旧保持对甲乙双方产生法律效力和影响。<br />
                        6.2 甲乙双方在履行本协议的过程中，如发生争议，应协商解决。协商不成的，双方均可向乙方所在地有管辖权的人民法院起诉。
                      </p>
                      <p>
                        <h3>七、免责条款</h3>
                        7.1 乙方在以下情况下不承担责任，包括但不限于：<br />
                        （1）如甲方在网吧等公众场所的公用电脑或其他网络设备、他人电脑或其他网络设备登录本网站平台，须谨慎操作，由此造成的信息泄露损失乙方不承担责任。<br />
                        （2）如果甲方在共享环境下或在电脑被远程监控的情况下登录本网站平台，由此造成的信息泄露损 失乙方不承担责任。<br />
                        （4）如因无法预见、无法避免且无法克服的不可抗力事件，导致乙方及其合作方在本协议 项下的义务无法履行或无法按时履行，则不应视为违约，也无需为此承担任何违约责任。<br />
                        （5）如果甲方蓄意欺诈、不按照适用于甲方的本协议条款和条件履行合理谨慎义务或不遵守安全操作要求，由此造成的损失乙方及其合作方不承担责任。<br />
                        （6）对于受到网络堵塞、中断、计算机病毒、木马或其他恶意程序、黑客攻击所造成的损失。
                      </p>
                      <p>
                        <h3>八、本协议的更新</h3>
                        8.1 在本协议履行过程中，因国家法律法规变化及本网站平台运营需要，乙方可根据情况对本服务协议进行修改。一旦本协议的内容发生变动，乙方将通过平台公布最新的服务协议，不再向甲方作个别通知。如果甲方不同意乙方对本协议所做的修改，甲方有权停止使用乙方服务。如果甲方继续使用服务，则视为甲方接受乙方对本协议所做的修改，并应遵照修改后的协议执行。
                      </p>
                    </span>
                    <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="dialogVisible = false">同 意</el-button>
                    </span>
                    </el-dialog>
                    <!-- <a>《普惠民间借贷服务平台用户协议》</a> -->
                </el-col>
            </el-row>

            </el-form>
        </div>
        <div class="btn_large">
            <el-button type="primary" class="btn_regist" size="large" v-on:click="onSubmit(openid,wxState)" v-loading.fullscreen.lock="fullscreenLoading" element-loading-spinner="el-icon-loading"
                       element-loading-background="rgba(255, 255, 255, 1)" element-loading-text="加载中，请稍后">完善个人信息</el-button>
        </div>
        <div class="btn_large">
            <el-button type="default" class="btn_regist" size="large" v-on:click="toWxLogin(openid,wxState)" v-loading.fullscreen.lock="fullscreenLoading" element-loading-spinner="el-icon-loading"
                   element-loading-background="rgba(255, 255, 255, 1)" element-loading-text="加载中，请稍后">已有账号?直接登录</el-button>
      </div>
    </div>
</template>
<script>
    import {reqGetWxRegister,reqWxPhoneCaptcha,reqRepeatUsername,reqCodeImg,reqCodeImageIsTrue} from '../../api/weixin-api'
    import {reqAddReferrer} from '../../api/weixin-api'
    import {get_access_token,get_isBinding_userInfo} from '../../api/weixin-api'
    import { Validator } from 'vee-validate';
    import {reqGetDictionaryListByCode,downloadFileURL} from '../../api/weixin-api';
    export  default {
        data(){
            return{
                countDownTime: 0,
                showRepeatUsername:false,
                educationArray:[],
                checked:true,
                dialogVisible:false,
                fullscreenLoading:false,
                captchaStatus:false,
                showPhoneCaptchaButton:false,
                btntxt: '获取短信验证码',
                downloadFileURL:downloadFileURL,
                clickCodeImage:false,
                inputCodeImage:false,
                openid:'',
                wxState:'',
                i:'',
                x:'',
                projectDetail:'',
                projectId:'',
                projectType:'',
                 loading:'',
                referrerId:'',
                 userId:'',
                form: {
                    username: '',
                    sex: '1',
                    age: '',
                    education: '',
                    phoneNumber: '',
                    onlyPhoneCode: '',
                    email: '',
                    codeImage:'',
                    phoneCaptcha: '',
                   onlyImgCode: '',
                    password: '',
                    openid:'',
                },
              RegisterRules: {
                username: [
                  {required: true, message: '请输入昵称', trigger: 'blur'},
                  {min: 1, max: 15, message: '昵称不能超过15个字符 ', trigger: 'blur'},
                  {pattern: /^[^ ]+[\s\S]*[^ ]+$/, message:'昵称前后不能有空格',trigger: 'blur'},
                ],
                sex: [
                  {required: true, trigger: 'change'},
                ],
                age: [
                  {required: true,label:'年龄', message: '请输入年龄', trigger: 'blur'},
                  {pattern: /^\d{2}$/,  message:'年龄只能是两位数',trigger: 'blur'},
                ],
                education: [
                  {required: true, message: '请选择学历'}
                ],
                phoneNumber: [
                  {required: true, message: '请输入手机号', trigger: 'blur'},
                  {pattern: /^1[3|4|5|7|8|9][0-9]{9}$/, message:'请输入正确的手机号',trigger: 'blur'},
                ],
                email : [
                  { message: '请输入邮箱', trigger: 'blur'},
                  { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                ],
                codeImage:[
                  {required: true, message: '请输入图形验证码', trigger: 'blur'},
                ],
                phoneCaptcha:[
                  {required: true, message: '请输入手机验证码', trigger: 'change'},
                ],
                password : [
                  {required: true, message: '请输入密码', trigger: 'blur'},
                  {pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/, message:'密码由字母和数字组成6到16个字符',trigger: 'blur'},
                ],
              },

            };
        },
        methods:{
            showUsername:function () {
                reqRepeatUsername({username:this.form.username}).then((res)=>{
                    if(res.data.data===1) {
                      this.showRepeatUsername=false;
                    }else if(res.data.code===2){
                        this.showRepeatUsername=true;
                        this.$message({
                        type:'warning',
                        message:'昵称重复，请使用其它账号注册'
                      })

                    }
                });
            },
            getDictionarys: function () {
                var that=this;
                reqGetDictionaryListByCode({code:'education'}).then((res) => {
                    that.educationArray = res.data.data;
                });
            },
//        获取图片验证码
            showCodeImg () {
                reqCodeImg().then((res) => {
                if(res.data.code===1){
                  document.getElementById('myCodeImg').src = downloadFileURL + res.data.data.fileName + '.jpg/'
                  this.form.onlyImgCode=res.data.data.onlyImgCode;
                }
                })
            },
// 获取手机验证码的时候先验证图形验证码
            getPhoneCaptcha:function () {
                if(this.form.codeImage===''||this.form.codeImage===null) {
                    this.$message({
                        message: '请先输入图像验证码',
                        type: 'warning'
                    });
                }else {
                    reqCodeImageIsTrue({codeImage:this.form.codeImage,onlyImgCode:this.form.onlyImgCode}).then((res)=>{
                    if(res.data.code!=4){
                        this.$message({
                            message: '图形验证码输入错误',
                            type: 'warning'
                        });
                    }else {
                        this.clickCodeImage=true;
                        this.inputCodeImage=true;
                        if (this.form.phoneNumber === '' || this.form.phoneNumber === null) {
                            this.$message({
                                message: '请输入手机号',
                                type: 'warning'
                            });
                        } else {
                            reqWxPhoneCaptcha({phoneNumber: this.form.phoneNumber}).then((res) => {
                                if (res.data.code === 4) {
                                    this.$message({
                                        message: '手机号已被注册，请使用新号码重新输入！',
                                        type: 'warning'
                                    });
                                    this.form.phoneNumber = '';
                                } else if (res.data.code === 3) {
                                    this.$message({
                                        message: '短信验证码发送异常，请稍后重新发送',
                                        type: 'warning'
                                    });
                                } else if (res.data.code === 2) {
                                    this.$message({
                                        message: '短信验证码发送失败，请稍后重新发送',
                                        type: 'warning'
                                    });
                                } else if (res.data.code === 1) {
                                    this.form.onlyPhoneCode=res.data.data;
                                    this.showPhoneCaptchaButton = true;
                                    this.countDownTime = 120;
                                    this.timer()
                                }
                            })
                        }
                    }
                    });
                }
            },

            //      手机验证码倒计时
            timer: function () {
                if (this.countDownTime > 0) {
                    this.countDownTime--;
                    this.btntxt = this.countDownTime + 'S';
                    setTimeout(this.timer, 1000)
                } else {
                    //  短信验证码一分钟后输入框设置为空，提示验证码过期，倒计时更改为获取验证码。
                    this.countDownTime = 0;
                    this.btntxt = '获取短信验证码';
                    this.showPhoneCaptchaButton=false;
                }
            },

// 用户注册.
            onSubmit (openid,wxState) {
                var that=this;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.$message({
                            message: '请填写符合规则的信息',
                            type: 'warning'
                        });
                        return false;
                    }
                    if(this.showRepeatUsername){
                        this.$message({
                            message: '昵称重复，该账号已被注册',
                            type: 'warning'
                        });
                        return false;
                    }
                    this.form.openid=openid;
                    let para = Object.assign({}, this.form);
                    if(this.checked==false){
                        this.$message({
                            message: '请仔细阅读并同意用户注册协议',
                            type: 'warning'
                        });
                    }else{
                        this.$refs.form.validate((valid) => {
                            if (valid) {
                                this.fullscreenLoading = true;
                                setTimeout(() => {
                                    this.fullscreenLoading = false;
                                    reqGetWxRegister(para).then((res) => {
                                        if (res.data.code ===1) {
                                          localStorage.setItem('Authorization', res.data.data.token);
                                          this.userId=res.data.data.userId;
                                          if(wxState){
                                            if(wxState.indexOf("PLR")!=-1){
                                              var i=wxState.indexOf("PLR");
                                              var x=wxState.indexOf("WX");
                                              this.i=i;
                                              this.x=x;
                                              this.projectId=wxState.substring(0,this.i);
                                              this.projectType=wxState.substring(this.i+3,this.x);
                                              this.projectDetail=wxState.substring(this.x+2,wxState.length);
                                              if(this.projectType === 'borrow'){
                                                this.$router.push({name: 'wxBorrowProjectDetail', query: {id: this.projectId,token:res.data.data.token,projectDetail:this.projectDetail}});
                                              }else if(this.projectType === 'loan'){
                                                this.$router.push({name: 'wxLoanProjectDetail', query: {id: this.projectId,token:res.data.data.token,projectDetail:this.projectDetail}});
                                              }else {
                                                this.$router.push({name: 'wxAssignmentDebtDetail', query: {id: this.projectId,token:res.data.data.token,projectDetail:this.projectDetail}});
                                              }
                                            }else if(wxState.indexOf("UID")!=-1){
                                              var j=wxState.indexOf("UID");
                                              this.referrerId=wxState.substring(0,j);
                                              let para={
                                                  userId:this.userId,
                                                  referrerId:this.referrerId,
                                              };
                                               reqAddReferrer(para).then((res)=>{
                                                 if(res.data.code===1){
                                                   this.$router.push({path:'wxMyHomePage'})
                                                 }
                                               });
                                            }else {
                                              this.$router.push({path:'wxMyHomePage',query:{token:res.data.data.token}})
                                            }
                                          }
                                            this.$message({
                                                message: '恭喜您，信息完善成功！',
                                                type: 'success'
                                            });
                                        } else if(res.data.code===4){
                                            this.fullscreenLoading = false;
                                            this.$message({
                                                message:'验证码错误',
                                                type: 'error'
                                            });
                                        }else if(res.data.code===5){
                                            this.fullscreenLoading = false;
                                            this.$message({
                                                message:'验证码失效',
                                                type: 'error'
                                            });
                                        }else if(res.data.code===3){
                                            this.fullscreenLoading = false;
                                            this.$message({
                                                message:'该账号已被注册',
                                                type: 'error'
                                            });
                                        }else {
                                          this.fullscreenLoading = false;
                                          this.$message({
                                            message:'完善信息失败',
                                            type: 'error'
                                          });
                                        }
                                    })
                                }, 2000)
                            } else {
                                console.log('error submit!!');
                                return false;
                            }
                        });
                    }
                }).catch(() => {
                });
            },
// 用户登录
          toWxLogin(openid,wxState){
            console.info(openid);
            console.info(wxState);
            this.$router.push({path:'wxLogin',query:{openid:openid,state:wxState}})
          },
// 授权返回
          getAccessToken: function (code,state) {
            var that=this;
            get_access_token({code:code}).then((res) => {
              if(res.data.code===1){
                this.openid=res.data.data;
// 拿到授权后返回的openid查询用户信息，如果能查到用户信息，说明此账号已经绑定了用户的微信信息，然后根据state的状态跳转不同的页面
// 备注：state为3时，跳转到用户中心，state为6时跳转到借贷大厅(这里的state需要根据跳转的链接在授权的请求中加上预定好的参数).
                get_isBinding_userInfo({openid:this.openid}).then((res)=>{
                  if(res.data.code===0){
                    this.loading.close();
                    console.info("使用授权openid没有查到用户信息，说明该用户为新用户或者已有账号用户，所以停留在完善信息页面，用户可完善信息或者直接登录")
                    if(state){
                      if(state.indexOf("PLL")!=-1){
                        this.$router.push({path:'wxLogin',query:{openid:this.openid,state:state}})
                      }
                    }
                  }else {
                    localStorage.setItem('Authorization', res.data.data.token);
                    console.info("该授权的微信号，已经绑定了用户账户，需要带上token到用户中心页面");
                    console.info("这里借贷大厅需要获取到state=projectId+projectType(跳转到具体的借入借出或者债权转让详情页)，然后跳转到借贷大厅")
                    if(state){
                      if(state.indexOf("PLR")!=-1){
                        var i=state.indexOf("PLR");
                        var x=state.indexOf("WX");
                        this.i=i;
                        this.x=x;
                        this.projectId=state.substring(0,this.i);
                        this.projectType=state.substring(this.i+3,this.x);
                        this.projectDetail=state.substring(this.x+2,state.length);
                        if(this.projectType === 'borrow'){
                          this.loading.close();
                          this.$router.push({name: 'wxBorrowProjectDetail', query: {id: this.projectId,token:res.data.data.token,projectDetail:this.projectDetail}});
                        }else if(this.projectType === 'loan'){
                          this.loading.close();
                          this.$router.push({name: 'wxLoanProjectDetail', query: {id: this.projectId,token:res.data.data.token,projectDetail:this.projectDetail}});
                        }else {
                          this.loading.close();
                          this.$router.push({name: 'wxAssignmentDebtDetail', query: {id: this.projectId,token:res.data.data.token,projectDetail:this.projectDetail}});
                        }
                      }else if(state.indexOf("PLL")!=-1){
                        var i=state.indexOf("PLL");
                        var x=state.indexOf("WX");
                        this.i=i;
                        this.x=x;
                        this.projectId=state.substring(0,this.i);
                        this.projectType=state.substring(this.i+3,this.x);
                        this.projectDetail=state.substring(this.x+2,state.length);
                        if(this.projectType === 'borrow'){
                          this.loading.close();
                          this.$router.push({name: 'wxBorrowProjectDetail', query: {id: this.projectId,token:res.data.data.token,projectDetail:this.projectDetail}});
                        }else if(this.projectType === 'loan'){
                          this.loading.close();
                          this.$router.push({name: 'wxLoanProjectDetail', query: {id: this.projectId,token:res.data.data.token,projectDetail:this.projectDetail}});
                        }else {
                          this.loading.close();
                          this.$router.push({name: 'wxAssignmentDebtDetail', query: {id: this.projectId,token:res.data.data.token,projectDetail:this.projectDetail}});
                        }
                      }else if(state.indexOf("UID")!=-1){
                        this.loading.close();
                        this.$router.push({name: 'wxProjectList'});
                      }else {
                        this.loading.close();
                        this.$router.push({path:'wxMyHomePage',query:{token:res.data.data.token}})
                      }

                    }
                  }
                })
              }
            });
          },
          isWechatBrowser: function () {
            let that=this;
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf('micromessenger') !== -1;
            if (!isWeixin) {
              that.$router.push({name: 'wxError'});
            }
          },
          toWxCompleteInfo:function() {
            pushHistory();

            function bodyScroll() {
              var state = {
                title: "title",
                url: ""
              };
              window.history.pushState(state, state.title, state.url);
            }

            window.addEventListener("popstate", bodyScroll, false)
            function pushHistory() {
              var state = {
                title: "title",
                url: ""
              };
              window.history.pushState(state, state.title, state.url);
            }

          }
        },
        mounted(){
         this.isWechatBrowser();
         var code= this.$route.query.code;
         var state= this.$route.query.state;
//          var code='111111';
//         var state= "67cd4b253e1541b3bce5ce4d5d7f8c77PRLborrowWxwxProjectList";
         this.$store.dispatch('hideHF');
         this.wxState=state;
          this.getDictionarys();
          this.showCodeImg();
          if(code){
            this.getAccessToken(code,state);
            this.loading = this.$loading({
              lock: true,
              text: '加载中，请稍后',
              spinner: 'el-icon-loading',
              background: 'rgba(255, 255, 255, 1)'
            });
          }else{
            this.openid=this.$route.query.openid;
            this.wxState=this.$route.query.wxstate;
          }
            this.toWxCompleteInfo();
          console.info("------state===========----------"+state);
        },
    }
</script>
<style slot-scope="scope">
    @import '../../assets/css/wxstyle.css';
    .disabledChangeCodeImage{
      pointer-events: none;
    }
    .transparent {
      pointer-events: none;
      filter: alpha(opacity=50); /*IE滤镜，透明度50%*/
      -moz-opacity: 0.5; /*Firefox私有，透明度50%*/
      opacity: 0.5; /*其他，透明度50%*/
    }
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxCompleteInfo.vue